import { Route } from 'react-router-dom';
import { GpoCustView } from '../../entities/custInfo/GpoCustView';
import { GpoRosterDashboard } from '../../entities/custInfo/GpoRosterDashboard';

const bmsMdRoutes = [
  <Route path="/md/gpo-roster-dashboard" element={<GpoRosterDashboard />} />,
  <Route path="/md/gpo-cust-view" element={<GpoCustView />} />,
];

export default bmsMdRoutes;
